module.exports = __webpack_public_path__ + "static/media/Training_Area_Light.8ed8edcd.svg";